import { render, staticRenderFns } from "./ticketStatisticsMove.vue?vue&type=template&id=496abfc8&scoped=true"
import script from "./ticketStatisticsMove.vue?vue&type=script&lang=js"
export * from "./ticketStatisticsMove.vue?vue&type=script&lang=js"
import style0 from "./ticketStatisticsMove.vue?vue&type=style&index=0&id=496abfc8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496abfc8",
  null
  
)

export default component.exports